// extracted by mini-css-extract-plugin
module.exports = {"w1krfszf":"w1krfszf","r5i0xb7":"r5i0xb7","ivi3zry":"ivi3zry","b1weo4r7":"b1weo4r7"};